import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoadingOverlayComponent } from './loading-overlay/loading-overlay.component';
import { ListHorizontComponent } from './list-horizont/list-horizont.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';

import { PlayerService } from './player.service';
import { WordpressService } from './wordpress.service';
import { HttpClientModule, HttpClient } from '@angular/common/http';

import {MaterialModule} from './material/material.module';

import { NgxMatomoTrackerModule } from '@ngx-matomo/tracker';
import { NgxMatomoRouterModule } from '@ngx-matomo/router';

@NgModule({
  declarations: [
    AppComponent,
    LoadingOverlayComponent,
    ListHorizontComponent,
    HeaderComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    MaterialModule,
    NgxMatomoTrackerModule.forRoot({ trackerUrl: 'https://analytics.audio-lab.org', siteId: '3' }),
    NgxMatomoRouterModule
  ],
  providers: [
    PlayerService,
    WordpressService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
